import { Text } from "native-base";
import FileUploader from "../../../../containers/fileUpload";
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from "../../../../utils/fonts";
import { COLORS } from "../../../../utils/colors";

const UploadPeople = ({ data, setData, forceRemount = false }) => {
  const onFileChange = (file) => {
    let fileData = { ...data };
    fileData.employee = file;
    setData(fileData);
  };

  return (
    <>
      {/* <FormHeader text="Upload People" /> */}
      <Text
        fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
        fontWeight={COMMONFONTWEIGHT.LARGE_FONT_WEIGHT}
        color={COLORS.ACCORDION_TITLE_COLOR}
      >
        Upload Board Members Details
      </Text>
      {data && (
        <FileUploader
          files={data.employee}
          setFiles={onFileChange}
          templates
          forceRemount={forceRemount}
        />
      )}
    </>
  );
};

export default UploadPeople;
